var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-upload"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload",
    clipPath: "url(#clip-upload)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(4.191 4.363)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 91.341,
    height: 91.341,
    transform: "translate(0 -0.033)",
    fill: "#fcfcfc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon",
    transform: "translate(0 8.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_04bd36ae-4e2b-4483-9437-316ed98307ac",
    "data-name": "04bd36ae-4e2b-4483-9437-316ed98307ac",
    d: "M40.585,27.564,23.928,10.908,7.272,27.564",
    transform: "translate(21.899 26.56)",
    fill: "none",
    stroke: "#6c39d2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    id: "_64f9d378-ac41-46f6-85d4-64b8f0715bec",
    "data-name": "64f9d378-ac41-46f6-85d4-64b8f0715bec",
    y2: 37.476,
    transform: "translate(45.827 37.467)",
    fill: "none",
    stroke: "#6c39d2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab537835-19b8-41b5-9154-e9aab5560720",
    d: "M81.666,66.8a20.819,20.819,0,0,0-9.95-39.1h-5.25A33.312,33.312,0,1,0,9.255,58.1",
    transform: "translate(-0.904 -2.729)",
    fill: "none",
    stroke: "#6c39d2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "ca1d1da1-742c-4226-bc27-e921cd17e9a4",
    d: "M40.585,27.564,23.928,10.908,7.272,27.564",
    transform: "translate(21.899 26.56)",
    fill: "none",
    stroke: "#6c39d2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.3721ab58f1c633e0da970ad75a38f001.svg";
export { ForwardRef as ReactComponent };